<div class="container-404">
    <div class="container-404__inner">
        <h1>404</h1>
        <h2>ресурс не найден</h2>
    </div>
</div>
